import React from 'react';
import { Check, Building2, TrendingUp } from 'lucide-react';
import { targetAudience } from '../data/mock';

const WhoItsFor = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-green-50/20 to-white" id="who-its-for">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#7AC943]/10 px-6 py-3 rounded-full mb-6">
              <Building2 className="h-5 w-5 text-[#7AC943]" />
              <span className="text-[#1F6FB2] font-semibold">Perfect For</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0E3A5F] mb-6">
              {targetAudience.title}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Left Column - Pain Points */}
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border-2 border-[#1F6FB2]/20 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <TrendingUp className="h-8 w-8 text-[#1F6FB2]" />
                <h3 className="text-2xl font-bold text-[#0E3A5F]">You might be a fit if you:</h3>
              </div>
              <ul className="space-y-4">
                {targetAudience.points.map((point, index) => (
                  <li key={index} className="flex items-start gap-3 group">
                    <div className="flex-shrink-0 w-6 h-6 bg-[#7AC943] rounded-full flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform duration-200">
                      <Check className="h-4 w-4 text-white" />
                    </div>
                    <span className="text-gray-700 text-lg leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column - Example Systems */}
            <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl border-2 border-[#7AC943]/20 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <Building2 className="h-8 w-8 text-[#7AC943]" />
                <h3 className="text-2xl font-bold text-[#0E3A5F]">Example Systems</h3>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {targetAudience.exampleSystems.map((system, index) => (
                  <div 
                    key={index}
                    className="bg-white p-4 rounded-xl border-2 border-gray-100 hover:border-[#7AC943] transition-all duration-200 hover:shadow-md text-center group cursor-default"
                  >
                    <span className="text-gray-700 font-semibold group-hover:text-[#1F6FB2] transition-colors duration-200">
                      {system}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-6 p-4 bg-[#7AC943]/10 rounded-xl border border-[#7AC943]/30">
                <p className="text-sm text-gray-600 text-center">
                  And many other industry-specific tools
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
